import React, { useEffect } from 'react';
import { useAnalyticsContext } from '@llt-frontend/react-analytics-context';
import Hero from '../components/hero';
import { PackagePicker } from '../components/packages';

import '../../styles/pages/self-service-page.scss';

const SelfServicePage = () => {
  const { trackEvent } = useAnalyticsContext();

  useEffect(() => {
    document.title = 'Tutoring Packages | Varsity Tutors';
  });

  useEffect(() => {
    trackEvent({
      category: 'visits',
      action: 'tutoring_packages',
    });
  }, [trackEvent]);

  return (
    <div className="self-service-page">
      <Hero />
      <PackagePicker />
    </div>
  );
};

export default SelfServicePage;
